(function(){
  'use strict';

  function init(){
    var shells=[].slice.call(document.querySelectorAll('[data-klx-video-shell]'));
    var passiveVideos=[].slice.call(document.querySelectorAll('[data-klx-passive-video]'));
    if(!shells.length && !passiveVideos.length)return;

    var state={soundEnabled:false,active:null,interactionArmed:true,needsGestureAudio:false};
    var manuallyPaused=new WeakSet();
    try{state.soundEnabled=localStorage.getItem('klxVideoSound')==='on';}catch(e){}

    function videoOf(shell){return shell&&shell.querySelector('[data-klx-audio-video]');}
    function playBtn(shell){return shell&&shell.querySelector('[data-klx-play-toggle]');}
    function soundBtn(shell){return shell&&shell.querySelector('[data-klx-sound-toggle]');}
    function isHero(shell){return shell&&shell.getAttribute('data-klx-video-section')==='hero';}
    function wantsAutoSound(shell){return shell&&shell.getAttribute('data-klx-autosound')==='true';}
    function isMobile(){return window.matchMedia&&window.matchMedia('(max-width: 720px)').matches;}

    function sync(shell){
      var video=videoOf(shell),p=playBtn(shell),s=soundBtn(shell);
      if(!video)return;
      if(p){
        var playing=!video.paused&&!video.ended;
        p.setAttribute('aria-pressed',playing?'true':'false');
        p.setAttribute('aria-label',playing?'Pause video':'Play video');
        var pl=p.querySelector('span'); if(pl)pl.textContent=playing?'Pause':'Play';
      }
      if(s){
        var on=!video.muted;
        s.setAttribute('aria-pressed',on?'true':'false');
        s.setAttribute('aria-label',on?'Turn video sound off':'Turn video sound on');
        var sl=s.querySelector('span'); if(sl)sl.textContent=on?'Sound off':'Sound on';
      }
    }

    function pauseShell(shell,temporary){
      var video=videoOf(shell); if(!video)return;
      if(!video.paused)video.pause();
      if(temporary){
        video.muted=true;
        video.defaultMuted=true;
      }
      if(state.active===shell)state.active=null;
      sync(shell);
    }

    function pauseAll(except){
      shells.forEach(function(shell){
        if(shell===except)return;
        pauseShell(shell,true);
      });
      passiveVideos.forEach(function(video){
        if(!video.paused)video.pause();
      });
    }

    function playWithPreference(shell,fromViewport){
      var video=videoOf(shell); if(!video)return Promise.resolve();
      if(fromViewport&&manuallyPaused.has(shell))return Promise.resolve();

      state.active=shell;
      pauseAll(shell);

      var wantsSound=state.soundEnabled||wantsAutoSound(shell);
      video.muted=!wantsSound;
      video.defaultMuted=!wantsSound;

      var pr;
      try{pr=video.play();}catch(e){pr=null;}
      if(pr&&pr.then){
        return pr.then(function(){
          if(wantsSound&&!video.muted){
            state.soundEnabled=true;
            state.needsGestureAudio=false;
            try{localStorage.setItem('klxVideoSound','on');}catch(e){}
          }
        }).catch(function(){
          video.muted=true;
          video.defaultMuted=true;
          if(wantsAutoSound(shell))state.needsGestureAudio=true;
          return video.play().catch(function(){});
        }).finally(function(){sync(shell);});
      }

      if(wantsSound&&!video.muted){
        state.soundEnabled=true;
        state.needsGestureAudio=false;
        try{localStorage.setItem('klxVideoSound','on');}catch(e){}
      }
      sync(shell);
      return Promise.resolve();
    }

    shells.forEach(function(shell){
      if(shell.dataset.klxVideoControlsReady==='true')return;
      shell.dataset.klxVideoControlsReady='true';

      var video=videoOf(shell),p=playBtn(shell),s=soundBtn(shell);
      if(!video)return;

      if(!isHero(shell)){
        video.muted=true;
        video.defaultMuted=true;
        if(!video.paused)video.pause();
      }

      p&&p.addEventListener('click',function(){
        if(video.paused){
          manuallyPaused.delete(shell);
          playWithPreference(shell,false);
        }else{
          manuallyPaused.add(shell);
          video.pause();
          if(state.active===shell)state.active=null;
          sync(shell);
        }
      });

      s&&s.addEventListener('click',function(){
        manuallyPaused.delete(shell);
        if(video.muted){
          state.soundEnabled=true;
          try{localStorage.setItem('klxVideoSound','on');}catch(e){}
          video.muted=false;
          video.defaultMuted=false;
          state.active=shell;
          pauseAll(shell);
          try{
            var p1=video.play();
            if(p1&&p1.catch)p1.catch(function(){});
          }catch(e){}
        }else{
          state.soundEnabled=false;
          try{localStorage.setItem('klxVideoSound','off');}catch(e){}
          video.muted=true;
          video.defaultMuted=true;
        }
        sync(shell);
      });

      video.addEventListener('play',function(){sync(shell);});
      video.addEventListener('pause',function(){sync(shell);});
      sync(shell);
    });

    var hero=shells.find(isHero);
    if(hero){
      var hv=videoOf(hero);
      if(hv){
        // Attempt true sound-on autoplay. Mobile Safari/Chrome may block this by policy;
        // if blocked, start muted and enable sound on the first real user gesture.
        hv.muted=false;
        hv.defaultMuted=false;
        var hp;
        try{hp=hv.play();}catch(e){hp=null;}
        if(hp&&hp.then){
          hp.then(function(){
            state.soundEnabled=true;
            state.active=hero;
            try{localStorage.setItem('klxVideoSound','on');}catch(e){}
            sync(hero);
          }).catch(function(){
            hv.muted=true;
            hv.defaultMuted=true;
            state.needsGestureAudio=true;
            state.active=hero;
            try{
              var mp=hv.play();
              if(mp&&mp.catch)mp.catch(function(){});
            }catch(e){}
            sync(hero);
          });
        }else{
          state.active=hero;
          sync(hero);
        }
      }
    }

    function enableSoundOnFirstInteraction(event){
      if(!state.interactionArmed)return;
      var target=event&&event.target;

      // Dedicated sound control owns its own gesture.
      if(target&&target.closest&&target.closest('[data-klx-sound-toggle]')){
        state.interactionArmed=false;
        return;
      }

      // A play/pause button should keep the user's explicit play/pause intent.
      if(target&&target.closest&&target.closest('[data-klx-play-toggle]')){
        state.interactionArmed=false;
        return;
      }

      state.interactionArmed=false;
      if(state.soundEnabled&&!state.needsGestureAudio)return;

      var shell=state.active||hero;
      var video=videoOf(shell);
      if(!video)return;

      state.soundEnabled=true;
      state.needsGestureAudio=false;
      try{localStorage.setItem('klxVideoSound','on');}catch(e){}
      video.muted=false;
      video.defaultMuted=false;
      manuallyPaused.delete(shell);
      state.active=shell;
      pauseAll(shell);

      try{
        var pr=video.play();
        if(pr&&pr.catch){
          pr.catch(function(){
            video.muted=true;
            video.defaultMuted=true;
            state.soundEnabled=false;
            state.needsGestureAudio=true;
            try{localStorage.setItem('klxVideoSound','off');}catch(e){}
            sync(shell);
          });
        }
      }catch(e){}
      sync(shell);
    }

    // Pointer/touch/keyboard gestures are the earliest legal point to enable audio
    // after mobile browsers block unmuted autoplay.
    ['pointerdown','touchstart','keydown'].forEach(function(evt){
      window.addEventListener(evt,enableSoundOnFirstInteraction,{once:true,passive:true});
    });

    if('IntersectionObserver' in window&&shells.length){
      var ratios=new Map();
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){ratios.set(entry.target,entry.intersectionRatio);});

        var activateAt=isMobile()?0.56:0.46;
        var pauseAt=isMobile()?0.38:0.28;
        var best=null,bestRatio=0;

        shells.forEach(function(shell){
          var r=ratios.get(shell)||0;
          if(r>bestRatio){best=shell;bestRatio=r;}
        });

        shells.forEach(function(shell){
          var r=ratios.get(shell)||0;
          if(shell===best&&r>=activateAt){
            if((state.active!==shell||videoOf(shell).paused)&&!manuallyPaused.has(shell)){
              playWithPreference(shell,true);
            }
          }else if(r<pauseAt || (state.active===shell&&r<activateAt)){
            pauseShell(shell,true);
          }
        });
      },{threshold:[0,.1,.2,.28,.38,.46,.56,.7,.85]});
      shells.forEach(function(shell){io.observe(shell);});
    }

    if('IntersectionObserver' in window&&passiveVideos.length){
      var pio=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var video=entry.target;
          video.muted=true;
          video.defaultMuted=true;
          if(entry.isIntersecting&&entry.intersectionRatio>=0.38&&!document.hidden){
            try{
              var pr=video.play();
              if(pr&&pr.catch)pr.catch(function(){});
            }catch(e){}
          }else{
            if(!video.paused)video.pause();
          }
        });
      },{threshold:[0,.15,.38,.6]});
      passiveVideos.forEach(function(video){pio.observe(video);});
    }

    document.addEventListener('visibilitychange',function(){
      if(document.hidden){
        shells.forEach(function(shell){pauseShell(shell,true);});
        passiveVideos.forEach(function(video){if(!video.paused)video.pause();});
      }
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();